import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { trimObjectStrings } from 'utils'
import Item from './item'
import { fetch, update, remove } from '../../actions'

const mapStateToProps = ({ requestReliefVehicles, settings }, ownProps) => {
  const { id } = ownProps
  const dataBooking = requestReliefVehicles.data?.[id] || null
  const dataContract =
    requestReliefVehicles.related?.[
      dataBooking?.vehicleDetails?.agreementNo ?? dataBooking?.agreementNo
    ] ??
    dataBooking?.vehicleDetails ??
    null

  const fetchStatus = requestReliefVehicles.flags?.fetch || 'none'
  const saveStatus = requestReliefVehicles.flags?.update || 'none'
  const errorMessage = requestReliefVehicles.errorMessage
  const fleetIds = settings.fleet.selected
  const userRoles = settings.roles

  let data = null

  if (dataBooking && dataBooking?.requestType === 'Relief') {
    data = {
      booking: trimObjectStrings(dataBooking),
      contract: trimObjectStrings(dataContract),
    }
  }

  if (dataBooking && dataBooking?.requestType === 'Rental') {
    data = {
      booking: trimObjectStrings(dataBooking),
    }
  }

  return {
    id,
    data,
    fleetIds,
    fetchStatus,
    saveStatus,
    userRoles,
    errorMessage,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetch: (id, fleetIds) => {
    const FleetId = fleetIds.join(',')
    dispatch(fetch(null, {
      resourceId: id,
      queryParams: { FleetId },
    }))
  },
  onUpdate: (payload) => {
    dispatch(update(payload, {
      resourceId: payload.id,
    }))
  },
  onDelete: (id, fleetId) => {
    dispatch(remove(null, {
      resourceId: id,
      queryParams: { fleetId },
    }))
  },
})

const ItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Item)

const ItemWithParams = (props) => {
  const { id } = useParams()
  return <ItemContainer {...props} id={id} />
}

export default ItemWithParams
